/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_Done_ReviewInputs */

const en_import_status_done_review = /** @type {(inputs: Import_Status_Done_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done · ready to review`)
};

const de_import_status_done_review = /** @type {(inputs: Import_Status_Done_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig · bereit zum Prüfen`)
};

/**
* | output |
* | --- |
* | "Done · ready to review" |
*
* @param {Import_Status_Done_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_done_review = /** @type {((inputs?: Import_Status_Done_ReviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_Done_ReviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_done_review(inputs)
	return en_import_status_done_review(inputs)
});